import { Box, Tooltip, Typography } from "@mui/material";
import { palette } from "../../styles/theme";
import { SpecsAssetImage } from "./SpecsEditorFields/index";
import { getAssetPreviewUrl } from "./specsEditorUtils";
import type { StyleModel } from "./specsModel/StyleModel";

export default function SpecsRightSidebarStyleChip({
  style,
  active,
  onClick,
}: {
  style: StyleModel;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <Tooltip title={style.name} placement="top">
      <Box
        component="button"
        onClick={onClick}
        sx={{
          width: 48,
          minHeight: 46,
          border: active
            ? `2px solid ${palette.brand.primary}`
            : `1px solid ${palette.grey.lightGrey}`,
          borderRadius: "6px",
          bgcolor: active ? palette.brand.paleEffect : "common.white",
          cursor: "pointer",
          p: 0.5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.25,
          color: active ? palette.brand.primary : "text.primary",
          font: "inherit",
          textAlign: "center",
          "&:hover": {
            borderColor: palette.brand.primary,
          },
        }}
      >
        {style.menuIconUrl ? (
          <SpecsAssetImage
            src={getAssetPreviewUrl(
              style.displayExtra,
              "menuIconUrl",
              style.menuIconUrl
            )}
            alt=""
            sx={{
              width: 16,
              height: 16,
              objectFit: "contain",
            }}
          />
        ) : null}
        <Typography
          variant="caption"
          sx={{
            width: "100%",
            fontSize: "9px",
            fontWeight: active ? 700 : 500,
            lineHeight: 1.2,
            overflowWrap: "anywhere",
          }}
        >
          {style.name}
        </Typography>
      </Box>
    </Tooltip>
  );
}
